export const API_URL = 'https://api.emss.pages.barakah.solutions';
